export const userDataKey = 'userData';
export const historyDataKey = (id: number) => `recent-${ id }`;